<div id="companyRoleModal">
  <h2 id="companyRoleTitle" class="tw-text-start tw-px-5">
    Help us personalize your experience
  </h2>
  <mat-dialog-content>
    <form
      #companyRoleForm="ngForm"
      id="forms.companyRoleForm"
      role="form"
      name="forms.companyRoleForm"
      autocomplete="on"
      novalidate
    >
      <div class="form-group">
        <label
          id="company-icp-role-label"
          for="company-icp-role"
          class="control-label"
        >
          Tell us your Company Role to help us make your experience great *
        </label>
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="tw-w-full"
        >
          <mat-select
            name="companyRole"
            id="company-icp-role"
            [(ngModel)]="user.companyRole"
            aria-labelledby="company-icp-role-label"
            placeholder="Select Role"
            autofocus
            required
          >
            @for (role of COMPANY_ROLE_FIELDS; track role) {
              <mat-option [value]="role[1]">{{ role[0] }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  <!-- //Modal Body -->
  <mat-dialog-actions align="center" class="tw-gap-2.5">
    <button
      rv-button
      id="saveButton"
      type="submit"
      class="tw-w-full"
      aria-label="Apply"
      tabindex="1"
      form="forms.companyRoleForm"
      (click)="save()"
      [disabled]="companyRoleForm.invalid"
    >
      Apply
      <i class="fa fa-check icon-right"></i>
    </button>
  </mat-dialog-actions>
</div>
